import { siteMediaUrl } from "../siteKit/media/siteMedia";
import type { ManualGuideKey } from "./manualGuides";
import { MANUAL_ASSET_DIRS } from "./manualMediaManifest";

/** 안내 단계 그림 주소(site-media-delivery) — `f<단계>-<폭>.webp` */
export const manualGuideFrameUrl = (
  key: ManualGuideKey,
  index: number,
  width: number
) => siteMediaUrl(`${MANUAL_ASSET_DIRS[key].d}/f${index}-${width}.webp`);

/** 첫 단계의 흐린 미리보기(data URI) — 그림을 받기 전 무대를 채운다 */
export const manualGuidePreview = (key: ManualGuideKey): string | undefined =>
  MANUAL_ASSET_DIRS[key].q;
